import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 24 24"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M15.682 3.018c1.553.112 3.135.772 4.62 2.078a.7.7 0 0 1-.926 1.05c-1.282-1.128-2.582-1.644-3.796-1.732-1.216-.088-2.394.25-3.436.91-1.24.787-2.27 2.022-2.905 3.489h4.605a.7.7 0 0 1 0 1.4h-5.07a8.237 8.237 0 0 0-.224 1.902c0 .445.038.882.111 1.309h5.184a.7.7 0 1 1 0 1.4H9.037c.602 1.626 1.718 2.996 3.1 3.846 2.065 1.271 4.74 1.394 7.267-.61a.7.7 0 0 1 .87 1.097c-3.007 2.385-6.326 2.272-8.871.705-1.789-1.1-3.187-2.91-3.843-5.038H4.16a.7.7 0 1 1 0-1.4h3.083a9.145 9.145 0 0 1-.094-1.309c0-.646.066-1.284.19-1.902H4.162a.7.7 0 0 1 0-1.4h3.573c.71-1.958 2.018-3.629 3.66-4.671 1.265-.802 2.738-1.237 4.288-1.124Z"
            clipRule="evenodd"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
